import { useContext, useState, useEffect } from 'react'
import ButtonEl from './ctas/Button'
import PercentValue from './PercentValue'
import themeConfig from '../../../theme.config'
import { detectShadeClash, transformPaddingToTailwind } from '../../helpers/style'
import { MarkupContext } from '../../providers/Markup'

function RatesCalloutBlock(props) {
  const { createMarkup, detectPaletteClass, getPaletteColor } = useContext(MarkupContext)
  const [activeVariant, setActiveVariant] = useState('0')
  const [highlightColor, setHighlightColor] = useState('secondary')

  const [disclaimers, setDisclaimers] = useState({})

  const handleSelect = ({ target }) => {
    setActiveVariant(target.value.toString())
  }

  useEffect(() => {
    setDisclaimers(() => {
      return {
        interest: rate.tokenRateList[activeVariant].interestRateDisclaimer,
        comparison: rate.tokenRateList[activeVariant].comparisonRateDisclaimer,
      }
    })
  }, [activeVariant])

  // this component explicitly uses the secondary shade so if it clashes with the selected background colour we need to change it.
  useEffect(() => {
    if (detectShadeClash(props.backgroundColor, getPaletteColor('secondary'))) {
      setHighlightColor('primary')
    }
  }, [])
  
  const rate = props.rate
  const i = props.i

  return (
    <div className={`basis-full shrink-0`} key={i}>
      <div className="mb-6">
        {rate.tokenRateList.length < 2 && (
          <>
            <strong className={detectPaletteClass('block text-sm font-bold leading-6 text-gray-900')}>{rate.tokenType}</strong>
            {themeConfig.settings.ratesCard.showVariantNames && rate.variants[0]?.variantName.length > 0 && (
              <strong className={detectPaletteClass('block text-sm font-bold leading-6 text-gray-900')}>
                {rate.variants[0]?.variantName}
              </strong>
            )}
          </>
        )}
        {rate.tokenRateList.length > 1 && (
          <>
            {rate.title.length > 0 && (
              <div className={detectPaletteClass('block text-sm font-bold leading-6 text-gray-900')}>{rate.title}</div>
            )}
            <label
              htmlFor={`${rate.tokenType?.replace(' ', '').toLowerCase()}-${rate.tokenCategory?.replace(' ', '').toLowerCase()}`}
              className={detectPaletteClass('block text-sm font-bold leading-6 text-gray-900')}
            >
              {rate.tokenType}
            </label>
            <select
              id={`${rate.tokenType?.replace(' ', '').toLowerCase()}-${rate.tokenCategory?.replace(' ', '').toLowerCase()}`}
              name={`${rate.tokenType?.replace(' ', '').toLowerCase()}-${rate.tokenCategory?.replace(' ', '').toLowerCase()}`}
              onChange={handleSelect}
              className={detectPaletteClass('mt-2 block w-full rounded-full border-0 border-primary-500 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6')}
            >
              {rate.variants.map((variant, idx) => (
                <option value={`${idx}`}>{variant.variantName}</option>
              ))}
            </select>
          </>
        )}
      </div>

      <div className="flex flex-wrap md:flex-nowrap gap-6 justify-center mb-6">
        {rate.tokenRateList[activeVariant].comparisonRate && (
          <div
            className={`${themeConfig.settings.ratesCard.highlightRate ? `text-${highlightColor}-500` : ''} basis-full md:basis-1/2`}
          >
            <PercentValue
              disclaimer={disclaimers.interest}
              rate={rate.tokenRateList[activeVariant].interestRate}
              rateType="Interest"
            />
          </div>
        )}
        {rate.tokenRateList[activeVariant].comparisonRate && (
          <div className="basis-full md:basis-1/2">
            <PercentValue
              disclaimer={disclaimers.comparison}
              rate={rate.tokenRateList[activeVariant].comparisonRate}
              rateType="Comparison"
            />
          </div>
        )}
      </div>
      {themeConfig.settings.ratesCard.showDisclaimersFromCMS && (
        <div className="mt-6 border-t-2 p-6 text-sm">
          {disclaimers.interest?.length > 0 && (
            <div>
              <sup>{themeConfig.settings.ratesCard.disclaimerIcons[0]}</sup> {disclaimers.interest}
            </div>
          )}
          {disclaimers.comparison?.length > 0 && (
            <div>
              <sup>{themeConfig.settings.ratesCard.disclaimerIcons[1]}</sup> {disclaimers.comparison}
            </div>
          )}
        </div>
      )}
      {rate.productDisclaimer?.length > 0 && (
        // {props.products && props.products[0]?.productDisclaimer?.length > 0 && (
        <div
          className="text-sm"
          data-rte="true"
          dangerouslySetInnerHTML={createMarkup(rate.productDisclaimer)}
        ></div>
      )}
      {props.showCtaLinks && rate.ctaLink?.length > 0 ? (
        <ul className={rate.productDisclaimer?.length > 0 ? "mt-3" : undefined}>
          {rate.ctaLink
            .filter((item) => item.link)
            .map((item, i) => (
              <li key={i} className="mb-6">
                <ButtonEl link={item.link} theme={item.linkType.toLowerCase()} className="justify-center! flex!" />
              </li>
            ))}
        </ul>
      ) : null}
    </div>
  )
}

export default RatesCalloutBlock
